export default "__VITE_ASSET__CNf1B7z4__"